import { ArrowRightOutlined, LoadingOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Card, Col, Collapse, Layout, Row, Spin, Tag, Typography } from "antd";
import { observer } from "mobx-react-lite";
import { FC, useEffect, useMemo } from "react";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import { Link } from "react-router-dom";
import supportAvatar from '../assets/support.jpg';
import { IntlButtons } from "../components/IntlButtons";
import { GlobalStore } from "../store/store";
import { formatPrice, getPrice, getProduct } from "../utils";

const { Content } = Layout;

interface IGoFarmPageProps {
  store: GlobalStore,
};

export const GoFarmPage: FC<IGoFarmPageProps> = observer(({ store }) => {
  useEffect(() => {
    if (store.products.length === 0) {
      store.getProducts("gofarm");
    }

    store.getIP();
  }, []);

  const { currency } = store;

  const products = useMemo(() => {
    return {
      anual: getProduct("anual", store.products),
      trimestral: getProduct("trimestral", store.products),
      // diario: getProduct("diario", store.products),
    };
  }, [store.products]);

  const discount = useMemo(() => {
    const p1 = products["anual"]?.[currency]?.UnitAmount;
    const p2 = products["trimestral"]?.[currency]?.UnitAmount;

    if (!p1 || !p2) {
      return 0;
    }

    return Math.round((1 - (p1 / (p2 * 4))) * 100 as any);
  }, [products, currency]);

  const price_anual = getPrice(products["anual"]?.[currency], currency)
  const price_trimestral = getPrice(products["trimestral"]?.[currency], currency)
  // const price_diario = getPrice(products["diario"]?.[currency], currency)

  const loading = store.loading || store.loading_ip;

  return (
    <Layout>
      <Content style={{ padding: '0 50px 50px 50px', width: 1150, margin: "auto" }}>
        <Breadcrumb style={{ margin: '16px 0' }}>
          <Breadcrumb.Item>Home</Breadcrumb.Item>
          <Breadcrumb.Item>{currency === "brl" ? "Produtos" : "Products"}</Breadcrumb.Item>
          <Breadcrumb.Item>GoFarm®</Breadcrumb.Item>
        </Breadcrumb>

        <Row gutter={30} style={{}}>
          <Col md={12} style={{ textAlign: "center" }}>
            <img src="img/gofarm.png" style={{ height: 300 }} alt="GoFarm Logo" />
          </Col>
          <Col md={12}>
            <Card style={{ height: 290 }}>
              <Typography.Title level={3} style={{ marginTop: 0 }}>
                GoFarm®

                <div style={{ float: "right" }}>
                  <IntlButtons store={store} />
                </div>
              </Typography.Title>

              <div style={{ height: 10 }} />

              {loading &&
                <Spin indicator={<LoadingOutlined />} />}

              {!loading &&
                <>
                  <Link to={`/gofarm/registro?plano=anual&moeda=${currency}`}>
                    <Card style={{ position: "relative" }}>
                      {(discount >= 3) &&
                        <div style={{ position: "absolute", marginLeft: -8, marginTop: -36, background: "#fff", padding: "0 8px" }}>
                          <Tag bordered={false} color="orange">{discount}% OFF</Tag>
                          {currency === "brl" ? "Opção Mais Popular" : "Popular Choice"}
                        </div>}
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <span style={{ display: "inline-block", width: 160 }}>
                            {currency === "brl" ? "Plano Anual" : "Annual Plan"}
                          </span>
                          <span>
                            {(discount >= 3) ?
                              <>
                                <p style={{ margin: 0, color: "#aaa" }}>
                                  <span style={{ display: "inline-block", width: 44 }}>
                                    {currency === "brl" ? "De:" : "From:"}
                                  </span>
                                  <span style={{ textDecoration: "line-through" }}>
                                    {formatPrice(products["trimestral"]?.[currency]?.UnitAmount! * 4, currency)}
                                  </span>
                                </p>
                                <p style={{ margin: 0 }}>
                                  <span style={{ display: "inline-block", width: 44 }}>
                                    {currency === "brl" ? "Por:" : "At:"}
                                  </span>
                                  <span>
                                    {price_anual}
                                  </span>
                                </p>
                              </>
                              :
                              <>
                                <p style={{ margin: 0 }}>
                                  {price_anual}
                                </p>
                              </>}

                          </span>
                        </div>
                        <Button type="primary">
                          <ArrowRightOutlined />
                        </Button>
                      </div>
                    </Card>
                  </Link>

                  <div style={{ height: 10 }} />

                  <Link to={`/gofarm/registro?plano=trimestral&moeda=${currency}`}>
                    <Card>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div>
                          <span style={{ display: "inline-block", width: 160 }}>
                            {currency === "brl" ? "Plano Trimestral" : "Quarterly Plan"}
                          </span>
                          {price_trimestral} {currency === "brl" ? "por trimestre" : "per quarter"}
                        </div>
                        <Button type="primary">
                          <ArrowRightOutlined />
                        </Button>
                      </div>
                    </Card>
                  </Link>
                  {/* 
                  <div style={{ height: 10 }} />

                  <Link to={`/gofarm/registro?plano=diario&moeda=${currency}`}>
                    <Card>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div>
                          <span style={{ display: "inline-block", width: 160 }}>Plano Diário</span>
                          {price_diario} / dia
                        </div>
                        <Button type="primary">
                          <ArrowRightOutlined />
                        </Button>
                      </div>
                    </Card>
                  </Link> */}
                </>}

            </Card>
          </Col>
        </Row>

        <div style={{ height: 40 }} />

        <Collapse
          defaultActiveKey={1}
          size="large"
          items={[
            {
              key: '1',
              label: (
                <strong>
                  {(currency === "brl") ?
                    "Descrição do Produto" :
                    "Product Description"}
                </strong>
              ),
              children: (
                (currency === "brl") ?
                  <div>
                    <p>
                      Executar o planejamento de linhas que servem para guiar, com precisão, tratores, pulverizadores e colheitadeiras e, exportar dados para maquinários com piloto automático.
                    </p>
                    <p>
                      <strong>Benefícios do uso</strong>
                    </p>
                    <ul>
                      <li>Mais aproveitamento das áreas e dos recursos tecnológicos adquiridos e disponíveis;</li>
                      <li>Mais qualidade do plantio e aumento da produtividade em campo;</li>
                      <li>Menos custo operacional a partir da redução de manobras e do aumento da precisão na execução de todas as operações no campo;</li>
                      <li>Aumento da competitividade dos usuários no mercado perante os concorrentes que não utilizam tecnologias de agricultura de precisão.</li>
                    </ul>
                    <p>
                      <strong>Diferenciais</strong>
                    </p>
                    <ul>
                      <li>Simples de usar;</li>
                      <li>Não precisa de outro ‘software plataforma’ para funcionar;</li>
                      <li>Baixo custo;</li>
                      <li>Agilidade no processamento;</li>
                      <li>Compatível com a maioria dos fabricantes e modelos de piloto automático existentes no mercado.</li>
                    </ul>
                  </div>
                  :
                  <div>
                    <p>
                      Create the path planning to accurately guide tractors, sprayers and harvesters and export data to machinery with autopilot.
                    </p>
                    <p>
                      <strong>Benefits</strong>
                    </p>
                    <ul>
                      <li>Greater use of areas and technological resources acquired and available;</li>
                      <li>Improved planting quality and increased productivity in the field;</li>
                      <li>Lower operational costs through reduced maneuvers and increased precision in the execution of all operations in the field;</li>
                      <li>Increased users' competitiveness in the market compared to competitors who do not use precision agriculture technologies.</li>
                    </ul>
                    <p>
                      <strong>Differences</strong>
                    </p>
                    <ul>
                      <li>Simple to use;</li>
                      <li>It does not require any other ‘software platform’ to work;</li>
                      <li>Low cost;</li>
                      <li>Agility in processing;</li>
                      <li>Compatible with most autopilot manufacturers and models on the market.</li>
                    </ul>
                  </div>
              )
            }
          ]}
        />

        <FloatingWhatsApp
          accountName="Suporte Tecgraf Agro"
          phoneNumber="+5519999174690"
          avatar={supportAvatar}
          statusMessage="Responde em poucos minutos"
          chatMessage={`Bem-vindo ao suporte Tecgraf Agro! 🤝

Como podemos ajudar?`}
          placeholder="Digite sua mensagem"
        />
      </Content>
    </Layout>
  );
})
